import axios from "axios";
import { getApiHeaders } from "../lib/apiHeaders";
import type { UploadInvoiceOptions, UploadInvoiceBatchResponse } from "../types/api";

export type { UploadInvoiceOptions, UploadInvoiceBatchResponse } from "../types/api";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

async function uploadConfig(businessId?: string) {
  return { headers: await getApiHeaders({ businessId }), timeout: 120_000 };
}

export async function uploadInvoicesForProcessing(
  files: File[],
  optionsOrBusinessId?: UploadInvoiceOptions | string,
): Promise<UploadInvoiceBatchResponse> {
  const options = typeof optionsOrBusinessId === "string"
    ? { businessId: optionsOrBusinessId }
    : optionsOrBusinessId || {};
  const form = new FormData();
  files.forEach((file) => form.append("files", file));
  if (options.source) form.append("source", options.source);
  if (options.deviceId) form.append("device_id", options.deviceId);
  if (options.documentMode) form.append("document_mode", options.documentMode);
  if (options.clientUploadIds?.length) form.append("client_upload_ids", JSON.stringify(options.clientUploadIds));
  if (options.clientChecksumsSha256?.length) form.append("client_checksums_sha256", JSON.stringify(options.clientChecksumsSha256));
  if (options.capturedAts?.length) form.append("captured_ats", JSON.stringify(options.capturedAts));

  try {
    const response = await axios.post(`${API_BASE_URL}/upload-invoice`, form, await uploadConfig(options.businessId));

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const data = error.response?.data;
      const detail = typeof data?.detail === "string" ? data.detail : undefined;
      const message = data?.error || detail || error.message;
      throw new Error(message);
    }

    throw error;
  }
}

export async function uploadInvoiceForProcessing(
  file: File,
  businessId?: string,
): Promise<UploadInvoiceBatchResponse> {
  return uploadInvoicesForProcessing([file], businessId);
}
